import { defineNuxtPlugin, useRouter, useState } from "#imports";
export default defineNuxtPlugin(() => {
  const router = useRouter();
  const redirectionsCount = useState("redirections-count", () => 0);
  router.afterEach((to, from, failure) => {
    if (!failure) {
      redirectionsCount.value = 0;
    }
  });
});
